module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_null_1@3x.4ab10f73.png";